<div class="d-flex align-items-center">
  <div
    class="c-field-value__shape-circle -sale-status mr-6"
    [ngClass]="{
      '-waiting': data.status === TokenStatuses.NO_RESTRICTIONS,
      '-pending': data.status === TokenStatuses.VALID_UNTIL,
      '-blocked': data.status === TokenStatuses.EXPIRED
    }"
  ></div>
  <gtd-ui-field-default-string-or-empty [data]="tokenStatusesLabels[data.status]"></gtd-ui-field-default-string-or-empty>
  <span *ngIf="data.status === TokenStatuses.VALID_UNTIL">&nbsp;{{ data.date }}</span>
</div>
